import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// Three, and in this order. The package exports them separately: the tokens are
// the values, base.css is what a bare element looks like, and styles.css is the
// components. Importing only the last one renders a page with every var()
// undefined, which is a screen with no spacing and no colour.
import "@depicomnlbv/platform-ui/tokens.css";
import "@depicomnlbv/platform-ui/base.css";
import "@depicomnlbv/platform-ui/styles.css";
// The map's two stylesheets (Leaflet's and map.css) are imported by
// components/DayMap.tsx, so they travel in the map's lazy chunk.
import "./components/nav.css";
import "./components/timeline.css";
import "./pages/pages.css";
import { App } from "./App";
import { configurationFailure, session } from "./auth/session";
import { NotConfigured } from "./components/NotConfigured";

const root = createRoot(document.getElementById("root")!);

if (configurationFailure) {
  // A production bundle without its Entra settings: one sentence, no planner.
  root.render(
    <StrictMode>
      <NotConfigured sentence={configurationFailure} />
    </StrictMode>,
  );
} else {
  // MSAL refuses every other call until initialize() has resolved, and a
  // redirect returning into an uninitialised instance loses the response it
  // came back with. So nothing renders until the session has read it, which is
  // also what lets the restored deep link be in the address before the router
  // reads it.
  void session
    .start()
    .catch((error: unknown) => {
      // A response that cannot be read is a sign-in that did not happen, and
      // the screen's own answer to that is its sign-in button. Logged, not
      // thrown: throwing here would leave the page blank instead.
      console.error("The sign-in response could not be read", error);
    })
    .then(() => {
      // BrowserRouter rather than a hash: the API answers any path it does not
      // own with index.html (`api/main.py`), so a deep link arrives at the
      // screen it names.
      root.render(
        <StrictMode>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </StrictMode>,
      );
    });
}
